import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class PasswordValidator {

    static passwordloginValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const forbidden = !passwordLoginRegEx.test(control.value);
            return forbidden ? { passwordLoginRegEx: { value: control.value } } : null;
        };
    }
}
// const passwordLoginRegEx: RegExp = /(?=[A-Za-z0-9@#$%^&+!=,./><'"()^#_=+{}[\]\-]|`~]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=,./><'"()^#_=+{}[\]\-]|`~])(?=.{8,}).*$/;
// const passwordLoginRegEx: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,}$/;
const passwordLoginRegEx: RegExp = /^(?=.*\d).{8,}$/;


// (?=.*[A-Z]) - At least lower case.
// (?=.*[a-z]) - At least upper case.
// (?=.*\d) - At least a number.
// (?=.*[!@#$%^&*()\-_=+{};:,<.>]) - At least special character.
// (?!.*\s) - No blank.
// .{8,} - Minimum 8 digits.